<template>
  <transition appear name="from-below">
    <v-row class="credits-block" align="top" justify="center">
      <v-col class="pb-16" cols="12" md="4" v-for="(role, i) in data.credits" :key="i">
        <h4 class="d-block">{{role.role}}</h4>
        <template v-for="(person, k) in role.people">
          <a class="name d-block" rel="noopener" target="_blank" :href="person.link" v-if="person.link"  :key="k">{{person.name}}</a>
          <div v-else class="name" :key="k">{{person.name}}</div>
        </template>
      </v-col>
    </v-row>
  </transition>
</template>

<script>

export default {
  name: 'ContentCredits',
  props: {
    data: {
      type: Object,
      required: true
    },
    full: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.credits-block {
  font-family: $heading-font-family;
}

h4 {
  font-size: 1.2em !important;
  text-transform: uppercase;
  margin-bottom: 0.5em;
}

.name {
  font-family: $body-font-family;
}
</style>
